import { render, staticRenderFns } from "./newLinkList.vue?vue&type=template&id=319ab6d3"
import script from "./newLinkList.vue?vue&type=script&lang=js"
export * from "./newLinkList.vue?vue&type=script&lang=js"
import style0 from "./newLinkList.vue?vue&type=style&index=0&id=319ab6d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports